import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  CustomInput,
  Button,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";
import { FaAngleDoubleLeft } from "react-icons/fa";
import NumberFormat from "react-number-format";
import axios from "axios";
import { useHistory } from "react-router-dom";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import AppConstants from "../AppConstants";
import { connect } from "react-redux";
import InfoIcon from "../images/info-icon.png";
import { CiEdit } from "react-icons/ci";
import { MdOutlineClose } from "react-icons/md";
import "./styles.scss";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Placeholder from "../images/placeholder.png";
import CloseIcon from "../images/close-icon.png";

function EditProfile(props) {
  const history = useHistory();
  const [showResumeUpload, setShowResumeUpload] = useState(false);

  // 🎯 Single form state - only added dateAvailable
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    primaryPhoneNumber: "",
    primaryEmail: "",
    countryCode: "1",
    profession: "",
    professionType: "",
    speciality: "",
    referralSource: "",
    otherReferralSource: "",
    referralBy: "",
    hasRecruiter: "",
    recruiter: "",
    dateAvailable: "", // Only new field added
    resume: "",
    ipAddress: ""
  });

  // 🎯 Single error state
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  // Options
  const [countryCodesArr, setCountryCodesArr] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [professionTypes, setProfessionTypes] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [referralSources, setReferralSources] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [modalEdit, setModalEdit] = useState(false);
  const [profileImageStatus, setProfileImageStatus] = useState(false);
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [profileImage, setProfileImage] = useState("");
  const [loader, setLoader] = useState(false);

  const token = localStorage.getItem("token");

  const toggleResumeUpload = () => {
    setShowResumeUpload(!showResumeUpload);
  };

  // ✅ Get IP address on load
  useEffect(() => {
    axios.get("https://api64.ipify.org?format=json").then((res) => {
      setForm((prev) => ({ ...prev, ipAddress: res.data.ip }));
    });
  }, []);

  // ✅ Get profile data on load
  // ✅ Get profile data on load - COMPLETELY FIXED VERSION

  const userId = localStorage.getItem("id");

  // Wrap fetchProfile in useCallback to avoid dependency warning
  const fetchProfile = React.useCallback(async () => {
    axios
      .get(`${AppConstants.API}/api/nurse/get-profile/${userId}`, {
        headers: {
          Authorization: token
        }
      })
      .then((res) => {
        if (res.data.Status === "Success" && res.data.data) {
          const data = res.data.data;
          console.log("API Profile Data:", data); // Debug log
          setProfileImage(data.profileImage);

          setForm((prev) => ({
            ...prev,
            firstName: data.firstName || "",
            lastName: data.lastName || "",
            primaryPhoneNumber:
              data.contactInformation?.primaryPhoneNumber || "",
            primaryEmail: data.contactInformation?.primaryEmail || "",
            countryCode: data.phoneCode || "1",

            // 🔥 FIXED: Use professionName instead of professionId for dropdown value
            profession:
              data.proffesionalInformation?.profession?.professionName || "",

            // 🔥 FIXED: Use CertName instead of CertId for dropdown value
            professionType:
              data.proffesionalInformation?.certifications?.[0]?.CertName || "",

            // 🔥 FIXED: Use SpecName instead of SpecId for dropdown value
            speciality:
              data.proffesionalInformation?.specialities?.[0]?.SpecName || "",

            referralSource: data.referralInformation?.referralSource || "",
            otherReferralSource:
              data.referralInformation?.otherReferralSource || "",
            referralBy: data.referralInformation?.referralBy || "",
            hasRecruiter: data.recruiter ? "yes" : "no",
            recruiter: data.recruiter || "",
            resume: data.resume || "",

            // 🔥 FIXED: Access dateAvailable from workPreferences
            dateAvailable:
              formatDateForInput(data.workPreferences?.dateAvailable) || ""
          }));

          // 🔥 LOAD DEPENDENT DROPDOWNS: Load profession types and specialties
          if (data.proffesionalInformation?.profession?.professionId) {
            loadProfessionTypes(
              data.proffesionalInformation.profession.professionId
            );
          }

          if (data.proffesionalInformation?.certifications?.[0]?.CertId) {
            loadSpecialties(
              data.proffesionalInformation.certifications[0].CertId
            );
          }
        }
      })
      .catch((err) => console.error("Error loading profile:", err));
  }, [userId, token]);

  useEffect(() => {
    // Get profile data - replace with actual user ID

    if (!userId || !token) return;

    fetchProfile();
  }, [fetchProfile, token, userId]);

  let imagePreview;

  const handleProfileImageChanges = (event) => {
    setProfileImageStatus(true);
    if (event.target.files[0]) {
      let reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrl(reader.result);
      };
      reader.readAsDataURL(event.target.files[0]);
    }
    setProfileImage(event.target.files[0]);
  };

  if (profileImage) {
    imagePreview = (
      <div className="previewText image-container">
        <img src={profileImage} alt={" - Travel Nurses Inc"} />
      </div>
    );
  } else {
    imagePreview = (
      <div className="previewText image-container">
        <img src={Placeholder} alt="Placeholder" />
      </div>
    );
  }
  if (imagePreviewUrl) {
    imagePreview = (
      <div className="image-container image-fill">
        <img src={imagePreviewUrl} alt={" - Travel Nurses Inc"} width="95" />{" "}
      </div>
    );
  }

  const handleProfileImageSubmit = (e) => {
    setLoader(true);
    let axiosConfig = {
      headers: {
        Authorization: token
      }
    };
    e.preventDefault();
    let formData = new FormData();
    formData.append("profileImage", profileImage);

    let url = AppConstants.API + "/nurse/updateNurseProfileImage/" + userId;
    axios
      .post(url, formData, axiosConfig)
      .then(function (response) {
        setLoader(false);
        if (response.data.Status == "Success") {
          let id = localStorage.getItem("id");
          props.getUserInfo(id);
          // getProfileListAPI();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  // 🔥 ADD THESE HELPER FUNCTIONS to load dependent dropdowns
  const loadProfessionTypes = async (professionId) => {
    try {
      const res = await axios.get(
        `${AppConstants.Jobs_API}/certification/getBullhornMatchedCertifications/${professionId}`
      );
      if (res.data.Status === "Success") {
        setProfessionTypes(res.data.data);
      }
    } catch (error) {
      console.error("Error loading profession types:", error);
    }
  };

  const loadSpecialties = async (certId) => {
    try {
      const res = await axios.get(
        `${AppConstants.Jobs_API}/specialities/getBullhornMatchedSpecialities/${certId}`
      );
      if (res.data.Status === "Success") {
        setSpecialties(res.data.data);
      }
    } catch (error) {
      console.error("Error loading specialties:", error);
    }
  };
  // ✅ Load dropdown options
  useEffect(() => {
    axios.get(AppConstants.Jobs_API + "/jobs/getAllCountries").then((res) => {
      if (res.data.Status === "Success") {
        setCountryCodesArr(res.data.data);
      }
    });

    axios
      .get(AppConstants.Jobs_API + "/professions/getAllProfessions")
      .then((res) => {
        if (res.data.Status === "Success") {
          setProfessions(res.data.data);
        }
      });

    axios
      .get(AppConstants.Jobs_API + "/specialities/getReferralSources")
      .then((res) => {
        if (res.data.Status === "Success" && res.data.data) {
          const sources = res.data.data.sort((a, b) =>
            a.referralSource.localeCompare(b.referralSource)
          );
          setReferralSources(sources);

          // If you want to set a default value (optional)
          const defaultSource = sources.find(
            (s) => s.referralSource === "Travel Nurses, Inc. Website"
          );
          if (defaultSource) {
            setForm((prev) => ({
              ...prev,
              referralSource: defaultSource.referralSource
            }));
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching referral sources:", err);
      });

    axios.get(AppConstants.API + "/users/getRecruitersListApp").then((res) => {
      if (res.data.Status === "Success") {
        const list = res.data.data.sort((a, b) =>
          a.label.toLowerCase().localeCompare(b.label.toLowerCase())
        );
        setRecruiters(list);
      }
    });
  }, []);

  // 🎯 Handle generic input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // 🎯 Handle phone number
  const handlePhoneChange = (values) => {
    setForm((prev) => ({ ...prev, primaryPhoneNumber: values.value }));
    if (values.value && values.value.length === 10) {
      setErrors((prev) => ({ ...prev, primaryPhoneNumber: "" }));
    }
  };

  // 🎯 Handle profession select
  const handleProfessionSelect = async (e) => {
    const value = e.target.value;
    setForm((prev) => ({
      ...prev,
      profession: value,
      professionType: "",
      specialty: ""
    }));
    setProfessionTypes([]);
    setSpecialties([]);

    if (value) {
      try {
        const prof = professions.find((p) => p.value === value);
        if (prof?._id) {
          const res = await axios.get(
            `${AppConstants.Jobs_API}/certification/getBullhornMatchedCertifications/${prof._id}`
          );
          if (res.data.Status === "Success") {
            setProfessionTypes(res.data.data);
          } else {
            setProfessionTypes([]);
          }
        }
      } catch (error) {
        console.error("Error fetching profession types:", error);
        setProfessionTypes([]);
      }
    }
  };

  const formatDateForInput = (isoDate) => {
    if (!isoDate) return "";
    try {
      const date = new Date(isoDate);
      return date.toISOString().split("T")[0]; // Converts "2025-07-15T00:00:00.000Z" to "2025-07-15"
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };
  // 🎯 Handle profession type select
  const handleProfessionTypeSelect = async (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, professionType: value, speciality: "" }));
    setSpecialties([]);

    if (value) {
      try {
        const cert = professionTypes.find((c) => c.value === value);
        if (cert?._id) {
          const res = await axios.get(
            `${AppConstants.Jobs_API}/specialities/getBullhornMatchedSpecialities/${cert._id}`
          );
          if (res.data.Status === "Success") {
            setSpecialties(res.data.data);
          } else {
            setSpecialties([]);
          }
        }
      } catch (error) {
        console.error("Error fetching specialties:", error);
        setSpecialties([]);
      }
    }
  };

  // 🎯 Handle recruiter radio
  const handleRecruiterRadio = (e) => {
    const hasRecruiter = e.target.value;

    setForm((prev) => ({
      ...prev,
      hasRecruiter,
      recruiter: hasRecruiter === "yes" ? prev.recruiter : ""
    }));

    setErrors((prev) => ({
      ...prev,
      hasRecruiter: "",
      recruiter: hasRecruiter === "yes" ? prev.recruiter : ""
    }));
  };

  // 🎯 Handle resume upload
  const handleResumeChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const ext = file.name.split(".").pop().toLowerCase();
      if (["pdf", "doc", "docx"].includes(ext)) {
        setForm((prev) => ({ ...prev, resume: file }));
        setErrors((prev) => ({ ...prev, resume: "" }));
      } else {
        setErrors((prev) => ({
          ...prev,
          resume: "Please upload only PDF or DOC files"
        }));
      }
    }
  };

  // 🎯 Validation - only added dateAvailable validation
  const validate = () => {
    const newErrors = {};

    if (!form.firstName) newErrors.firstName = "Please enter your first name.";
    if (!form.lastName) newErrors.lastName = "Please enter your last name.";
    if (!form.primaryEmail) newErrors.primaryEmail = "Please enter your email.";
    if (
      form.primaryEmail &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.primaryEmail)
    ) {
      newErrors.primaryEmail = "Please enter a valid email.";
    }
    if (!form.primaryPhoneNumber)
      newErrors.primaryPhoneNumber = "Please enter your phone number.";
    else if (form.primaryPhoneNumber.length !== 10)
      newErrors.primaryPhoneNumber = "Please enter a valid phone number.";

    if (!form.profession)
      newErrors.profession = "Please select your profession.";
    if (!form.professionType)
      newErrors.professionType = "Please select your profession type.";
    if (!form.speciality)
      newErrors.speciality = "Please select your specialty.";

    if (!form.referralSource)
      newErrors.referralSource = "Please select how did you hear about us?";
    if (form.referralSource === "Other" && !form.otherReferralSource)
      newErrors.otherReferralSource = "Please enter other referral source.";
    if (!form.referralBy)
      newErrors.referralBy = "Please enter did someone refer you?";

    if (!form.hasRecruiter)
      newErrors.hasRecruiter = "Please select whether you have a recruiter.";
    if (form.hasRecruiter === "yes" && !form.recruiter)
      newErrors.recruiter = "Please select a recruiter.";

    if (!form.countryCode) newErrors.countryCode = "Please select country code";

    if (!form.dateAvailable)
      newErrors.dateAvailable = "Please enter your availability date."; // Only new validation

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // 🎯 Submit - only changed API call and added dateAvailable
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);

    let formData = new FormData();
    formData.append("ipAddress", form.ipAddress);
    formData.append("path", "web");
    formData.append(
      "contactInformation",
      JSON.stringify({
        primaryEmail: form.primaryEmail.toLowerCase(),
        primaryPhoneNumber: form.primaryPhoneNumber
      })
    );
    formData.append("firstName", form.firstName);
    formData.append("lastName", form.lastName);
    formData.append("resume", form.resume);
    formData.append("phoneCode", form.countryCode);
    formData.append("dateAvailable", form.dateAvailable); // Only new field added
    if (form.hasRecruiter === "yes" && form.recruiter) {
      formData.append("recruiter", form.recruiter);
    }

    formData.append(
      "referralInformation",
      JSON.stringify({
        referralSource: form.referralSource,
        referralBy: form.referralBy,
        otherReferralSource: form.otherReferralSource
      })
    );
    // ✅ ✅ ✅ ADD THIS BLOCK HERE:
    const selectedProfession = professions.find(
      (p) => p.value === form.profession
    );
    const selectedCert = professionTypes.find(
      (c) => c.value === form.professionType
    );
    const selectedSpec = specialties.find((s) => s.value === form.speciality);

    console.log("Selected Profession:", selectedProfession);
    console.log("Selected Certification:", selectedCert);
    console.log("Selected Specialty:", selectedSpec);

    formData.append(
      "proffesionalInformation",
      JSON.stringify({
        profession: {
          professionId: selectedProfession?._id,
          professionName: selectedProfession?.profession
        },
        certifications: [
          {
            CertId: selectedCert?._id,
            CertName: selectedCert?.certification,
            bullhornEntityId: selectedCert?.bullhornEntityId
          }
        ],
        specialities: [
          {
            SpecId: selectedSpec?._id,
            SpecName: selectedSpec?.speciality,
            bullhornEntityId: selectedSpec?.bullhornEntityId
          }
        ]
      })
    );

    // Make API call to update profile
    const response = await axios.post(
      `${AppConstants.API}/api/bullhorn/nurse/edit/${userId}`,
      formData,
      {
        headers: {
          Authorization: token,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "multipart/form-data"
        }
      }
    );

    if (profileImageStatus) {
      handleProfileImageSubmit(e);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }

    if (response.data.Status === "Success") {
      NotificationManager.success(response.data.msg, "", 5000);
      // history.push("/profile");
    } else {
      NotificationManager.error(response.data.msg, "", 5000);
    }

    console.log("Update response:", response.data);

    // Changed from registerUser to updateUser
    setTimeout(() => setIsLoading(false), 2000);
  };

  const togglesendmail = (item) => {
    setModalEdit(true);
    if (
      item == "first name" ||
      item == "last name" ||
      item == "mobile phone" ||
      item == "email" ||
      item == "profession" ||
      item == "profession type" ||
      item == "speciality" ||
      item == "referral source" ||
      item == "referral by" ||
      item == "recruiter"
    ) {
      setEditKey(item);
    }
  };
  const [modal, setModal] = useState(false);
  const [editKey, setEditKey] = useState("");
  const [subLoader, setSubLoader] = useState(false);
  const [comments, setComments] = useState("");
  const [commentsErr, setCommentsErr] = useState(false);

  const [userInfo1, setUser1] = useState((prevState) => ({
    firstName: prevState ? prevState.firstName : "",
    lastName: prevState ? prevState.lastName : ""
  }));

  const [primaryDetails1, setPrimaryDetails1] = useState((prevState) => ({
    primaryEmail: prevState ? prevState.primaryEmail : "",
    primaryPhoneNumber: prevState ? prevState.primaryPhoneNumber : ""
  }));
  const handleClose = (e) => {
    e.preventDefault();
    setModal(false);
    setModalEdit(false);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setCommentsErr(false);
    if (comments === "") {
      setCommentsErr(true);
    } else {
      setSubLoader(true);
      let axiosConfig = {
        headers: {
          Authorization: token
        }
      };

      await axios
        .post(
          AppConstants.API + "/nurse/sendMailOnNurseEditProfile",
          { comments: comments, subjectType: editKey },

          axiosConfig
        )
        .then((res) => {
          setSubLoader(false);
          setCommentsErr(false);
          setComments("");
          setModalEdit(false);
          res.data.Status === "Success"
            ? NotificationManager.success(res.data.msg, "", 5000)
            : NotificationManager.error(res.data.msg, "", 5000);
        });
    }
  };

  const handleComments = (e) => {
    setComments(e.target.value);
    setCommentsErr(false);
    if (e.target.value == "") {
      setCommentsErr(true);
    } else {
      setCommentsErr(false);
    }
    setComments(e.target.value);
  };

  const handleEditButton = () => {
    // getProfileListAPI();
    // setEditStatus(!editStatus);
  };

  // ✨ Same JSX as registration form, only added dateAvailable field before resume:
  return (
    <>
      <Modal
        isOpen={modalEdit}
        toggle={togglesendmail}
        className="modal-lg recruiter-modal edit-profile-modal"
        id="Tn-popup"
        style={{ color: "#25408f", fontWeight: "500" }}
      >
        <div className="main-page">
          <ModalHeader
            toggle={(e) => handleClose(e)}
            className="text-center pt-4 pb-1"
            style={{ color: "#25408f" }}
          ></ModalHeader>
          <ModalBody className="p-0">
            <Form className="inner-block">
              <div className="btn-block">
                <h6>
                  Please contact the TNI compliance team to edit your {editKey}.
                </h6>
                <Col xl="12" sm="12" className="block">
                  <FormGroup>
                    <Label for="comments">
                      Comments
                      <span style={{ color: "red" }}>*</span>
                    </Label>
                    <Input
                      type="textarea"
                      name="editComments"
                      placeholder="Please Enter Your Comments..."
                      id="comments"
                      value={comments}
                      onChange={(e) => handleComments(e)}
                    />
                    <span>
                      {commentsErr == true ? (
                        <span className="error" style={{ color: "red" }}>
                          Please enter your comments
                        </span>
                      ) : (
                        ""
                      )}
                    </span>
                  </FormGroup>
                </Col>

                <a
                  value="Submit"
                  className="blue-bttn"
                  onClick={handleEditSubmit}
                  style={{
                    fontFamily: "Figtree Black",
                    backgroundColor: "#334ca4"
                  }}
                >
                  Submit
                  {false ? (
                    <img
                      src={`${AppConstants.Bucket_URL}/bannerImages/loader.gif`}
                      alt="No Image"
                      style={{ width: 40, height: 40 }}
                    />
                  ) : (
                    ""
                  )}
                </a>
              </div>
            </Form>
          </ModalBody>
        </div>
      </Modal>
      <div className="main-page registr-info apply-form accordian-block">
        <Container>
          <div className="preview-bttn back-bttn">
            <button
              className="button back-btn float-none w-auto"
              onClick={() => history.push("/profile/" + userId)}
            >
              <FaAngleDoubleLeft />
              <span>Back To Dashboard</span>
            </button>
          </div>

          <div className="registration-form search-block">
            <div className="title">Profile</div>

            <h5 className="text-center">Edit your details below.</h5>

            <Form className="inner-block block pt-0" onSubmit={handleSubmit}>
              <div>
                <div className="profile-cont-grid">
                  <Form className="view-info  profile-info d-flex justify-content-center">
                    <div className="view-page">
                      <div className="profile-sec file-upload row ">
                        <div className="image-sec col-sm-4">
                          <div className="">
                            {imagePreview}
                            <Input
                              type="file"
                              name="profileImage"
                              id="upload"
                              accept="image/png, image/jpeg"
                              className="cursor-pointer"
                              onChange={handleProfileImageChanges}
                            />
                            <Label
                              for="upload"
                              className="file-label cursor-pointer"
                              style={{ cursor: "pointer" }}
                            ></Label>

                            <div className="clear"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                </div>
                <Form className="form-block personal-info">
                  <Row>
                    <Col xs="6" className="block">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            First Name
                            <span style={{ color: "red" }}>
                              *
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() => togglesendmail("first name")}
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>
                        <Input
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          value={form.firstName}
                          onChange={handleChange}
                          disabled
                        />
                        {errors.firstName && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.firstName}
                          </span>
                        )}
                      </FormGroup>
                    </Col>

                    <Col xs="6" className="block">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            Last Name
                            <span style={{ color: "red" }}>
                              *
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() => togglesendmail("last name")}
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="lastName"
                          placeholder="Last Name"
                          value={form.lastName}
                          onChange={handleChange}
                          disabled
                        />
                        {errors.lastName && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.lastName}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className="codephone-blk">
                    <Col xs="2" className="block country-code disable-field">
                      <FormGroup>
                        <Label>Country Code</Label>
                        <Input
                          type="select"
                          name="countryCode"
                          value={form.countryCode}
                          onChange={handleChange}
                          disabled
                        >
                          {countryCodesArr.map((code, i) => (
                            <option key={i} value={code.phoneCode}>
                              {code.phoneCode === 1 ? "USA" : code.name}{" "}
                              {"+" + code.phoneCode}
                            </option>
                          ))}
                        </Input>
                        {errors.countryCode && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.countryCode}
                          </span>
                        )}
                      </FormGroup>
                    </Col>

                    <Col xs="5" className="block phone-input">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            Phone Number
                            <span style={{ color: "red" }}>
                              *{" "}
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() =>
                                      togglesendmail("mobile phone")
                                    }
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>

                        <NumberFormat
                          format="(###) ###-####"
                          mask=""
                          placeholder="Phone Number"
                          value={form.primaryPhoneNumber}
                          onValueChange={handlePhoneChange}
                          className="form-control"
                          disabled
                        />
                        {errors.primaryPhoneNumber && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.primaryPhoneNumber}
                          </span>
                        )}
                      </FormGroup>
                    </Col>

                    <Col xs="5" className="block">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            Email
                            <span style={{ color: "red" }}>
                              *{" "}
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() => togglesendmail("email")}
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="primaryEmail"
                          placeholder="Email"
                          value={form.primaryEmail}
                          onChange={handleChange}
                          disabled
                        />
                        {errors.primaryEmail && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.primaryEmail}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs="6" className="inout-block certi-bttn ">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            Profession
                            <span style={{ color: "red" }}>
                              *{" "}
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() => togglesendmail("profession")}
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>

                        <Input
                          type="select"
                          name="profession"
                          value={form.profession}
                          onChange={handleProfessionSelect}
                          className="custom-dropdown"
                          disabled
                        >
                          <option value="">Select Any</option>
                          {professions.map((item, index) => (
                            <option value={item.value} key={index}>
                              {item.value}
                            </option>
                          ))}
                        </Input>
                        {errors.profession && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.profession}
                          </span>
                        )}
                      </FormGroup>
                    </Col>

                    <Col xs="6" className="inout-block certi-bttn">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            Profession Type
                            <span style={{ color: "red" }}>
                              *{" "}
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() =>
                                      togglesendmail("profession type")
                                    }
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>

                        <Input
                          type="select"
                          name="professionType"
                          value={form.professionType}
                          onChange={handleProfessionTypeSelect}
                          className="custom-dropdown"
                          disabled
                        >
                          <option value="">Select Any</option>
                          {professionTypes.map((item, index) => (
                            <option value={item.value} key={index}>
                              {item.value}
                            </option>
                          ))}
                        </Input>
                        {errors.professionType && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.professionType}
                          </span>
                        )}
                      </FormGroup>
                    </Col>

                    <Col xs="6" className="inout-block">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            Specialty
                            <span style={{ color: "red" }}>
                              *{" "}
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() => togglesendmail("speciality")}
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>

                        <Input
                          type="select"
                          name="speciality"
                          value={form.speciality}
                          onChange={handleChange}
                          className="custom-dropdown"
                          disabled
                        >
                          <option value="">Select Any</option>
                          {specialties.map((item, index) => (
                            <option value={item.value} key={index}>
                              {item.value}
                            </option>
                          ))}
                        </Input>
                        {errors.speciality && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.speciality}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <p className="px-3">
                    Note: Please only select 1 specialty in which you have 1
                    full year of experience within the last 3 years. If you need
                    to select additional specialties, please notify your
                    recruiter.
                  </p>

                  <Row>
                    <Col xs="6" className="block">
                      <FormGroup>
                        <div className="help-tip">
                          {" "}
                          <Label>
                            How did you hear about us?
                            <span style={{ color: "red" }}>
                              *{" "}
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() =>
                                      togglesendmail("referral source")
                                    }
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>

                        <Input
                          type="select"
                          name="referralSource"
                          value={form.referralSource}
                          onChange={handleChange}
                          className="custom-dropdown"
                          disabled
                        >
                          <option value="">Select</option>
                          {referralSources.map((ele, index) => (
                            <option value={ele.referralSource} key={index}>
                              {ele.referralSource}
                            </option>
                          ))}
                        </Input>
                        {errors.referralSource && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.referralSource}
                          </span>
                        )}
                      </FormGroup>
                    </Col>

                    {form.referralSource === "Other" && (
                      <Col xs="6" className="block">
                        <FormGroup>
                          <Label>
                            Other Referral Source{" "}
                            <>
                              {" "}
                              <figure>
                                <img src={InfoIcon} alt="Info-Icon" />
                              </figure>
                              <p>
                                You are not allowed to edit this info, our
                                Recruiter Team will update your details please
                                <a
                                  href="javascript:void()"
                                  onClick={() =>
                                    togglesendmail("referral source")
                                  }
                                >
                                  {" "}
                                  click here
                                </a>
                              </p>
                            </>
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                          <Input
                            type="text"
                            name="otherReferralSource"
                            placeholder="Other Referral Source"
                            value={form.otherReferralSource}
                            onChange={handleChange}
                            disabled
                          />
                          {errors.otherReferralSource && (
                            <span className="error" style={{ color: "red" }}>
                              {errors.otherReferralSource}
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                    )}

                    <Col xs="6" className="block">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            Did someone refer you?{" "}
                            <>
                              {" "}
                              <figure>
                                <img src={InfoIcon} alt="Info-Icon" />
                              </figure>
                              <p>
                                You are not allowed to edit this info, our
                                Recruiter Team will update your details please
                                <a
                                  href="javascript:void()"
                                  onClick={() => togglesendmail("referral by")}
                                >
                                  {" "}
                                  click here
                                </a>
                              </p>
                            </>
                            <span style={{ color: "red" }}>*</span>
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="referralBy"
                          placeholder="Please enter who referred you?"
                          value={form.referralBy}
                          onChange={handleChange}
                          disabled
                        />
                        <p className="helper">
                          Please enter "n/a" if not referred by Word of Mouth.
                        </p>
                        {errors.referralBy && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.referralBy}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs="12" className="block mt-3">
                      <FormGroup>
                        <div className="help-tip">
                          <Label>
                            Do you have a recruiter?
                            <span className="error" style={{ color: "red" }}>
                              *{" "}
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() => togglesendmail("recruiter")}
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </span>
                          </Label>
                        </div>

                        <div className="check-sec d-flex">
                          <span className="radio-form-action">
                            <Input
                              type="radio"
                              name="hasRecruiter"
                              id="hasRecruiterYes"
                              value="yes"
                              checked={form.hasRecruiter === "yes"}
                              onChange={handleRecruiterRadio}
                              disabled
                            />
                            <Label
                              htmlFor="hasRecruiterYes"
                              className="check-field ml-3"
                              style={{ lineHeight: "120%" }}
                            >
                              I already have a recruiter
                            </Label>
                          </span>
                          <span className="radio-form-action">
                            <Input
                              type="radio"
                              name="hasRecruiter"
                              id="hasRecruiterNo"
                              value="no"
                              checked={form.hasRecruiter === "no"}
                              onChange={handleRecruiterRadio}
                              disabled
                            />
                            <Label
                              htmlFor="hasRecruiterNo"
                              className="check-field ml-3"
                              style={{ lineHeight: "120%" }}
                            >
                              I do not have a recruiter
                            </Label>
                          </span>
                        </div>
                        {errors.hasRecruiter && (
                          <span className="error" style={{ color: "red" }}>
                            {errors.hasRecruiter}
                          </span>
                        )}
                      </FormGroup>
                    </Col>
                  </Row>

                  {form.hasRecruiter === "yes" && (
                    <Row>
                      <Col xs="6" className="block">
                        <FormGroup>
                          <div className="help-tip">
                            <Label>
                              Do you have a recruiter you want to work with?{" "}
                              <>
                                {" "}
                                <figure>
                                  <img src={InfoIcon} alt="Info-Icon" />
                                </figure>
                                <p>
                                  You are not allowed to edit this info, our
                                  Recruiter Team will update your details please
                                  <a
                                    href="javascript:void()"
                                    onClick={() => togglesendmail("first name")}
                                  >
                                    {" "}
                                    click here
                                  </a>
                                </p>
                              </>
                            </Label>
                          </div>

                          <Input
                            type="select"
                            name="recruiter"
                            value={form.recruiter}
                            onChange={handleChange}
                            className="custom-dropdown"
                            // disabled={recruiters.length === 0}
                            disabled
                          >
                            <option value="">
                              {recruiters.length === 0
                                ? "No recruiters available"
                                : "Select"}
                            </option>
                            {recruiters.map((item, index) => (
                              <option value={item.value} key={index}>
                                {item.label}
                              </option>
                            ))}
                          </Input>
                          {errors.recruiter && (
                            <span className="error" style={{ color: "red" }}>
                              {errors.recruiter}
                            </span>
                          )}
                        </FormGroup>
                      </Col>

                      <Col xs="6" className="block">
                        <FormGroup>
                          <div className="help-tip">
                            <Label>
                              Date Available
                              <span style={{ color: "red" }}>
                                *{" "}
                                <>
                                  {" "}
                                  <figure>
                                    <img src={InfoIcon} alt="Info-Icon" />
                                  </figure>
                                  <p>
                                    You are not allowed to edit this info, our
                                    Recruiter Team will update your details
                                    please
                                    <button
                                      type="button"
                                      className="link-button"
                                      onClick={() =>
                                        togglesendmail("first name")
                                      }
                                      style={{
                                        background: "none",
                                        border: "none",
                                        padding: 0,
                                        color: "#007bff",
                                        textDecoration: "underline",
                                        cursor: "pointer"
                                      }}
                                    >
                                      {" "}
                                      click here
                                    </button>
                                  </p>
                                </>
                              </span>
                            </Label>
                          </div>

                          <Input
                            type="date"
                            name="dateAvailable"
                            value={form.dateAvailable}
                            onChange={handleChange}
                            style={{ cursor: "pointer" }}
                          />
                          {errors.dateAvailable && (
                            <span className="error" style={{ color: "red" }}>
                              {errors.dateAvailable}
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                  )}

                  {form.resume && (
                    <span className="resume-title">
                      <a
                        href={form.resume}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Resume
                      </a>
                      <span
                        onClick={toggleResumeUpload}
                        style={{ cursor: "pointer", marginBottom: "15px" }}
                      >
                        {showResumeUpload ? (
                          <MdOutlineClose size={20} />
                        ) : (
                          <CiEdit size={20} style={{ color: "#007bff" }} />
                        )}
                      </span>
                    </span>
                  )}

                  {showResumeUpload && (
                    <Row>
                      <Col xs="12" className="block resume-button">
                        <FormGroup>
                          <Label>Resume</Label>
                          <span className="upload-doc">
                            <InputGroup className="mb-3">
                              <InputGroupAddon addonType="prepend">
                                Upload
                              </InputGroupAddon>
                              <CustomInput
                                type="file"
                                id="upload"
                                name="resume"
                                onChange={handleResumeChange}
                              />
                            </InputGroup>
                            {errors.resume && (
                              <span className="error" style={{ color: "red" }}>
                                {errors.resume}
                              </span>
                            )}
                          </span>
                        </FormGroup>
                      </Col>
                    </Row>
                  )}
                </Form>
              </div>

              <Row className="justify-content-center">
                <Col md="12">
                  <button
                    type="submit"
                    className="btn btn-next button w-auto"
                    title="Update"
                  >
                    Update
                    {isLoading && (
                      <img
                        src={`${AppConstants.Bucket_URL}/bannerImages/loader.gif`}
                        alt="Loading..."
                        style={{ width: 40, height: 40 }}
                      />
                    )}
                    <i className="fa fa-angle-right" aria-hidden="true"></i>
                  </button>
                </Col>
              </Row>
            </Form>

            <NotificationContainer />
          </div>
        </Container>
      </div>
    </>
  );
}

export default EditProfile;
